import React from 'react'
import cn from 'classnames'
import * as s from './MovingLogoBlock.module.scss'
import MrGroupGrayLogo from './svg/mr-group-gray-logo'
import X5GroupGrayLogo from './svg/X5-group-gray-logo'
import HalsGrayLogo from './svg/hals-gray-logo'
import SminexGrayLogo from './svg/sminex-gray-logo'
import SberbankDevelopmentGrayLogo from './svg/sberbank-development-gray-logo'
import AkvilonGrayLogo from './svg/akvilon-gray-logo'
import PioneerGrayLogo from './svg/pioneer-gray-logo'
import GolosGrayLogo from './svg/golos-gray-logo'
import LevelGroupGrayLogo from './svg/level-group-gray-logo'
import GlavstrojGrayLogo from './svg/glavstroj-gray-logo'
import MosinzhproektGrayLogo from './svg/mosinzhproekt-gray-logo'

const partners = [
  { Icon: MrGroupGrayLogo },
  { Icon: X5GroupGrayLogo },
  { Icon: HalsGrayLogo },
  { Icon: SminexGrayLogo },
  { Icon: SberbankDevelopmentGrayLogo },
  { Icon: AkvilonGrayLogo },
  { Icon: PioneerGrayLogo },
  { Icon: GolosGrayLogo },
  { Icon: LevelGroupGrayLogo },
  { Icon: GlavstrojGrayLogo },
  { Icon: MosinzhproektGrayLogo },
]

const MovingLogoBlock = () => {
  return (
    <div className={s.itemsWrap}>
      <div className={cn(s.items, s.marquee)}>
        {partners.map(({ Icon }, idx) => (
          <div className={s.item} key={idx}>
            <Icon className={s.icon} />
          </div>
        ))}
      </div>
      <div aria-hidden={true} className={cn(s.items, s.marquee)}>
        {partners.map(({ Icon }, idx) => (
          <div className={s.item} key={idx}>
            <Icon className={s.icon} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default MovingLogoBlock
